import React, { useState } from 'react';
import {
  Button,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle
} from 'reactstrap';
import { MdOutlineContactPhone } from 'react-icons/md';
import SendMessageContactsModal from './components/SendMessageContactsModal';
import CallContactsModal from './components/CallContactsModal';
import SendEmailModal from './components/SendEmailContactsModal';

const OpportunityActionsModal = ({ opportunityData }) => {
  const [dropdown, setDropdown] = useState(false);

  const [isSendMessageModalContactsOpen, setIsSendMessageModalContactsOpen] =
    useState(false);
  const [isCallModalContactsOpen, setIsCallModalContactsOpen] = useState(false);
  const [isEmailModalContactsOpen, setIsEmailModalContactsOpen] =
    useState(false);

  const [isToGetContacts, setIsToGetContacts] = useState(false);

  const toggle = () => setDropdown(!dropdown);

  const openSendMessageModal = () => {
    setIsSendMessageModalContactsOpen(!isSendMessageModalContactsOpen);
    setIsToGetContacts(!isToGetContacts);
  };

  const openCallContactModal = () => {
    setIsCallModalContactsOpen(!isCallModalContactsOpen);
    setIsToGetContacts(!isToGetContacts);
  };

  const openSendEmailModal = () => {
    setIsEmailModalContactsOpen(!isEmailModalContactsOpen);
    setIsToGetContacts(!isToGetContacts);
  };

  return (
    <>
      <Button color="success" onClick={toggle} size="sm">
        <MdOutlineContactPhone size={17} />
      </Button>
      <Dropdown
        isOpen={dropdown}
        toggle={toggle}
        style={{ top: '-110px', left: '0' }}
      >
        <DropdownToggle
          color="link"
          style={{
            margin: '0',
            padding: '0'
          }}
        ></DropdownToggle>
        <DropdownMenu style={{ maxHeight: '7rem' }}>
          <DropdownItem
            value="Enviar mensagem whatsapp"
            onClick={() => openSendMessageModal()}
            disabled={!opportunityData.accountId}
            style={{ padding: '0.3rem 1rem' }}
          >
            <i className="fas fa-comment" />
            Enviar mensagem whatsapp
          </DropdownItem>
          <DropdownItem
            value="Realizar chamada"
            onClick={() => openCallContactModal()}
            disabled={!opportunityData.accountId}
            style={{ padding: '0.3rem 1rem' }}
          >
            <i className="fas fa-phone" />
            Realizar chamada
          </DropdownItem>
          <DropdownItem
            value="Enviar email"
            onClick={() => openSendEmailModal()}
            disabled={!opportunityData.accountId}
            style={{ padding: '0.3rem 1rem' }}
          >
            <i className="fas fa-envelope" />
            Enviar email
          </DropdownItem>
        </DropdownMenu>
      </Dropdown>
      <SendMessageContactsModal
        accountId={opportunityData.accountId}
        opportunityData={opportunityData}
        isToGetContacts={isToGetContacts}
        recordTypeId={opportunityData.accountRecordTypeId}
        isModalOpen={isSendMessageModalContactsOpen}
        onModalToggle={setIsSendMessageModalContactsOpen}
      />
      <CallContactsModal
        accountId={opportunityData.accountId}
        opportunityData={opportunityData}
        isToGetContacts={isToGetContacts}
        recordTypeId={opportunityData.accountRecordTypeId}
        isModalOpen={isCallModalContactsOpen}
        onModalToggle={setIsCallModalContactsOpen}
      />

      <SendEmailModal
        accountId={opportunityData.accountId}
        opportunityData={opportunityData}
        isToGetContacts={isToGetContacts}
        recordTypeId={opportunityData.accountRecordTypeId}
        isModalOpen={isEmailModalContactsOpen}
        onModalToggle={setIsEmailModalContactsOpen}
      />
    </>
  );
};

export default OpportunityActionsModal;
